export const genderOptions = [
    { value: 0, name: 'Mulher' },
    { value: 1, name: 'Homem' },
    { value: 2, name: 'Mulher trans' },
    { value: 3, name: 'Homem trans' },
    { value: 4, name: 'Não-binário' },
    { value: 5, name: 'Agênero' },
    { value: 6, name: 'Genderqueer' },
    { value: 7, name: 'Prefiro não responder' },
    { value: 8, name: 'Não listado' }
];
// export const sexOptions = [
//     { value: 0, name: 'Feminino' },
//     { value: 1, name: 'Masculino' },
//     { value: 2, name: 'Não-binário/Intersexo' }
// ];
export const healthSystemTypes = [
    { value: 0, name: 'Serviço Nacional de Saúde (SNS)' },
    { value: 1, name: 'Seguro de Saúde Privado' },
    { value: 2, name: 'Saúde Complementar' },
    { value: 3, name: 'Cuidados de Saúde Privados' }
];
